module.exports = __webpack_public_path__ + "fonts/5e191338/proximanova-light-webfont.eot";